import { transferHoldProblem } from "@components/scheduling/settings/settingsValidation";

const inputClass =
  "w-32 border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500";
const labelClass = "block text-xs font-medium text-gray-600 mb-1";

/**
 * How long the engine stays quiet after it hands a patient to the front desk.
 *
 * One number box. An empty box is "no pause" and reaches the draft as null,
 * which is the value the server stores for it; a number reaches the draft as
 * a number, even one outside 0–60, so the red text under the box can say so
 * and the Save button can refuse it before the server does.
 */
export default function TransferHoldEditor({ minutes, onChange }) {
  const problem = transferHoldProblem(minutes);

  return (
    <div>
      <label className={labelClass} htmlFor="transfer-hold-minutes">
        Minutes to wait before the next call
      </label>
      <input id="transfer-hold-minutes" type="number" min="0" max="60" step="1"
             className={inputClass}
             placeholder="No pause"
             value={minutes ?? ""}
             onChange={(e) => onChange(e.target.value === "" ? null : Number(e.target.value))} />
      <p className="mt-1 text-xs text-gray-500">
        After a patient is transferred to your front desk, the AI waits this long before
        dialing anyone else, so the desk is free to take them. Leave empty for no pause.
      </p>
      {problem && <p className="mt-1 text-xs text-red-600">{problem}</p>}
    </div>
  );
}
